/**
 * @author Camilo
 * @since  19/11/2018
 */
export class RegistroNegocioPendienteModel{

    constructor(public negocio:string, public cantidad:number, public activarUsuario:boolean,public pendientesAprobacionContab:number){}

}

export class DescargarIntefazNegocio{

    constructor(public nombre:string, public ruta:string, public fecha:Date){}

}




// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/DescargarInterfaz/RegistroNegocioPendiente.model.ts